import Image from 'next/image'
import Link from 'next/link'

import cl from './style.module.scss'

export const FollowUs = () => {
	return (
		<section className={cl.follow}>
			<div className={cl.wrapper}>
				<div className={cl.content}>
					<h2 className={cl.title}>Присоединяйся к&nbsp;нашей команде</h2>

					<p className={cl.subtitle}>Узнать о&nbsp;доступных вакансиях</p>
					<Link prefetch={false} href="https://nbcomgroup.ru/" className={cl.btn} target={'_blank'}>
						Подробнее
					</Link>
				</div>
				<Image
					src={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/promo-service/last-banner.png'}
					alt={''}
					width={598}
					height={414}
					quality={100}
					className={cl.img}
				/>
			</div>
		</section>
	)
}
